export const SET_COMPANYDETAILS = "SET_COMPANYDETAILS";
export const SET_COMPANYNULL = "SET_COMPANYNULL";
